/* src/app/forms/painel-correios/cep-disponibilidade/cep-disponibilidade.component.scss */
.cep-content {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}
.cep-fields-grid {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
mat-form-field {
  width: 100%;
}
button {
  width: 100%;
  font-size: 90%;
}
.cep-font {
  font-size: 90%;
}
.button-check {
  width: 100%;
  text-align: end;
}
.columns-data {
  width: 50%;
  padding: 2px;
}
.mensagem {
  font-size: 120%;
  padding: 10px;
  text-align: center;
  height: 100%;
}
/*# sourceMappingURL=cep-disponibilidade.component.css.map */
